import { Component, AfterViewInit, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { InactivityService } from './services/inactivity.service';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'lms';

  constructor(
    private router: Router,
    private inactivity: InactivityService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Always scroll to top after route change
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit(): void {
    // If user refreshes the page while already logged in, restart the inactivity timer
    if (localStorage.getItem('authToken')) {
      this.inactivity.start();
    }
  }

  ngAfterViewInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        // Google Analytics page view tracking
        if (window.gtag) {
          window.gtag('event', 'page_view', {
            page_path: event.urlAfterRedirects,
            page_location: window.location.href,
            page_title: document.title
          });
        }

        // Wait until the next view is fully rendered
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        }, 100);
      });
  }
}